import { Box, Button, Container } from '@mui/material';
import HeaderBreadcrumbs from 'src/components/header-bread-crumbs/HeaderBreadcrumbs';
import Page from 'src/components/page/page';
import useShopkeepers from './shopkeepers.hook';
import CNLoading from 'src/components/loading-cn/CNLoading';
import TableRox from 'src/components/table-rox/TableRox';
import { paths } from 'src/routes/paths';

export default function Shopkeepers() {
  const { isLoadingShopkeepersList, shopkeepersList, TABLEHEADER, permissions, navigate } = useShopkeepers();

  return (
    <Page title="Lista de lojistas">
      <Container maxWidth="lg">
        <HeaderBreadcrumbs
          heading="Lista de Lojistas"
          links={[]}
          action={
            <Button variant="contained" onClick={() => navigate(paths.dashboard.shopkeeperCreate)} disabled={!permissions?.create}>
              Cadastrar Lojista
            </Button>
          }
        />
        {isLoadingShopkeepersList ? (
          <Box flexGrow={1} display="flex" justifyContent="center" alignItems="center" mt={30}>
            <CNLoading />
          </Box>
        ) : (
          <TableRox
            data={shopkeepersList}
            header={TABLEHEADER}
            defaultOrderBy="name"
            hasSearch
            selectKey="_id"
            selectType="none"
            onClickKey="_id"
            onClickFunction={(id) => navigate(paths.dashboard.shopkeeperDetails(id))}
          />
        )}
      </Container>
    </Page>
  );
}
